import styled, { css } from 'styled-components';

import { MEDIA_QUERIES } from "@constants";
import { getCaretCSS } from "@utils";

const ClassesPageClassDetails2UPStyles = css`
  padding: 60px 60px calc(var(--spacing--2XL) + var(--spacing--L));

  h4 {
    font-size: var(--font-size--h2);
  }

  p {
    font-size: var(--font-size--M);
  }
`

export const ClassesPageClassDetailsDIV = styled.div`
  position: relative;
  box-shadow: var(--elevation--S);
  border-radius: 6px;
  padding: 30px 30px 88px;
  max-width: 100%;
  overflow: hidden;
  background-color: #fff;

  ${MEDIA_QUERIES.M} {
    padding: 40px 40px 88px;
  }

  ${MEDIA_QUERIES.L} {
    padding: 40px 40px 260px;
    
    .classes-count--1 & {
      padding: 40px 40px max(var(--spacing--XL), 110px);
    }
  }

  ${MEDIA_QUERIES.XL} {
    .classes-count--2 &,
    .classes-count--4 & {
      ${ClassesPageClassDetails2UPStyles}
    }

    .classes-count--5 & {
      &:nth-child(1) {
        grid-column: 1 / 4;
        ${ClassesPageClassDetails2UPStyles}
      }

      &:nth-child(2) {
        grid-column: 4 / 7;
        ${ClassesPageClassDetails2UPStyles}
      }

      &:nth-child(3) {
        grid-column: 1 / 3;
      }

      &:nth-child(4) {
        grid-column: 3 / 5;
      }

      &:nth-child(5) {
        grid-column: 5 / 7;
      }
    }
  }
`;

export const ClassesPageClassDetailsContentDIV = styled.div`
  ${MEDIA_QUERIES.L} {
    .classes-count--1 & {
      width: 40%;
    }
  }

  h4 {
    font-size: 24px;
    margin: 0 0 20px;
  }

  p {

    ${MEDIA_QUERIES.L} {
      margin: 0;
    }
  }
`

export const ClassesPageClassTimesWrapperDIV = styled.div`
  position: relative;
  width: 100%;
  margin: 40px 0 0;

  ${MEDIA_QUERIES.L} {
    position: absolute;
    bottom: 88px;
    top: auto;
    left: 40px;
    right: auto;
    width: calc(100% - 80px);
    transform: none;

    .classes-count--1 & {
      width: 40%;
      inset: 0 40px auto auto;
    }
  }

  ${MEDIA_QUERIES.XL} {
    .classes-count--2 &,
    .classes-count--4 & {
      bottom: 108px;
      left: 60px;
      width: calc(100% - 120px);
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: -30px;
    width: calc(30% + 30px);
    height: 100%;
    background: linear-gradient(270deg, #FFFFFF 14.1%, rgba(255, 255, 255, 0) 88.41%);
    border-right: 30px solid white;
    pointer-events: none;

    ${MEDIA_QUERIES.M} {
      right: -40px;
      width: calc(30% + 40px);
    }

    ${MEDIA_QUERIES.XL} {
      .classes-count--2 &,
      .classes-count--4 & {
        right: -60px;
        width: calc(30% + 60px);
      }
    }
  }

  .back {
    position: absolute;
    left: -30px;
    z-index: 2;
    width: 30px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .Icon {
      background: var(--color--charcoal-600);
      transition: background 0.3s;
    }

    &:hover .Icon {
      background: var(--color--charcoal-600);
    }

    ${MEDIA_QUERIES.M} {
      left: -40px;
      width: 40px;
    }

    ${MEDIA_QUERIES.XL} {
      .classes-count--2 &,
      .classes-count--4 & {
        left: -60px;
        width: 60px;
      }
    }
  }
`;

export const ClassesPageClassTimesDIV = styled.div`
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.3s;

  > div {
    flex: 0 0 max(calc(var(--spacing--XL)*.75), 100px);
    height: 130px;
    margin-right: 20px;
    border-radius: 4px;
    background: var(--color--charcoal-100);
  }

  button {
    flex: 0 0 max(calc(var(--spacing--XL)*.75), 100px);
    margin-right: 20px;
    padding: 18px 0 20px;
    border-radius: 4px;
    background: var(--color--charcoal-100);
    color: var(--color--charcoal-700);
    transition: all 0.3s;

    &:hover {
      background: var(--color--charcoal-200);
    }

    &.is-active {
      background: var(--color--cobalt-800);
      color: white;

      .PURPLE & {
        background: var(--color--purple-800);
      }

      .WHALETAIL & {
        background: var(--color--slate-800);
      }
    }

    span {
      display: block;
      text-align: center;
    }

    .date {
      font-size: 48px;
      line-height: 58px;
      font-weight: 500;
      margin-bottom: 4px;
    }

    .time {
      font-size: var(--font-size--overline-S);
      font-style: italic;
    }
  }
`;

export const ClassesPageHeroRegisterBUTTON = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 58px;
  line-height: 54px;
  font-weight: 500;
  background: var(--color--cobalt-100);
  border-top: 1px solid var(--color--cobalt-200);
  color: var(--color--cobalt-700);
  text-align: center;

  &::after {
    ${getCaretCSS()}
  }

  &:hover {
    background: var(--color--cobalt-200);
    color: var(--color--cobalt-800);

    &::after {
      transform: rotate(45deg) translateX(2px) translateY(-2px);
    }
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 2px var(--color--cobalt-600);
  }

  .PURPLE & {
    background: var(--color--purple-100);
    border-top: 1px solid var(--color--purple-200);
    color: var(--color--purple-700);

    &:hover {
      background: var(--color--purple-100);
      color: var(--color--purple-800);
    }
  }


  .WHALETAIL & {
    background: var(--color--slate-100);
    border-top: 1px solid var(--color--slate-200);
    color: var(--color--slate-700);

    &:hover {
      background: var(--color--slate-200);
      color: var(--color--slate-800);
    }
  }

  .is-empty &,
  .is-empty &:hover {
    background: var(--color--charcoal-100);
    color: var(--color--charcoal-700);
    border-top: 1px solid var(--color--charcoal-200);
    
    &::after {
      display: none;
    }
  }
`;
